import React from 'react';

export type CardProps = React.HTMLAttributes<HTMLDivElement> & {
  pad?: boolean | 'lg';
  hover?: boolean;
};

export const Card = React.forwardRef<HTMLDivElement, CardProps>(
  ({ pad, hover, className = '', ...rest }, ref) => {
    const cls = [
      'card',
      pad === true ? 'card-pad' : pad === 'lg' ? 'card-pad-lg' : '',
      hover ? 'card-hover' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ');
    return <div ref={ref} className={cls} {...rest} />;
  }
);
Card.displayName = 'Card';

export const CardHeader: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className = '',
  ...rest
}) => <div className={`card-header ${className}`} {...rest} />;

export const CardTitle: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className = '',
  ...rest
}) => <div className={`card-title ${className}`} {...rest} />;
